import React from "react";

export default function TermsDialog({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="terms-overlay" onClick={onClose}>
      <div className="terms-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="terms-dialog-header">
          <div>
            <h2 className="terms-title">Terms &amp; Conditions</h2>
            <p className="terms-updated">Last Updated: 1 February, 2025</p>
          </div>
          <button className="terms-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="terms-body">
          <h3>1. Acceptance of Terms</h3>
          <p>By engaging with Rising Sun Globalized Firm ("the Firm"), you agree to be bound by these Terms &amp; Conditions. These terms constitute a legal agreement between the Firm and the Client.</p>

          <h3>2. Scope of Services</h3>
          <p>The Firm provides specialized technology services including AI-native engineering, medical diagnostic software, and cloud architecture. All services are governed by the specific Service Level Agreements (SLAs) and Statements of Work (SOW) executed between the parties.</p>

          <h3>3. Intellectual Property Rights</h3>
          <ul>
            <li><strong>Work Product:</strong> Ownership of custom software and deliverables shall transfer to the Client only upon receipt of full and final payment.</li>
            <li><strong>Retained Rights:</strong> Rising Sun retains ownership of its foundational code, pre-existing frameworks, and proprietary AI methodologies used during development.</li>
          </ul>

          <h3>4. Data Protection &amp; Privacy (India Compliance)</h3>
          <p>The Firm complies with the Information Technology Act, 2000 and the Digital Personal Data Protection Act (DPDP), 2023.</p>
          <ul>
            <li><strong>Sensitive Data:</strong> For medical machine-reading data, we implement the "Privacy by Design" principle.</li>
            <li><strong>Data Processing:</strong> Clients are responsible for obtaining necessary consents from end-users before processing data through our developed systems.</li>
          </ul>

          <h3>5. Limitation of Liability</h3>
          <p>To the maximum extent permitted by Indian law, Rising Sun shall not be liable for any indirect, punitive, or consequential damages.</p>
          <ul>
            <li><strong>Medical Disclaimer:</strong> Our software is an analytical tool. The Firm is not responsible for clinical outcomes or diagnostic errors made by healthcare professionals using the software.</li>
          </ul>

          <h3>6. Indemnification</h3>
          <p>The Client agrees to indemnify and hold Rising Sun harmless from any claims, losses, or legal fees arising out of the Client's misuse of the developed technology or violation of third-party intellectual property rights.</p>

          <h3>7. Governing Law &amp; Jurisdiction</h3>
          <p>These Terms shall be governed by and construed in accordance with the Laws of India. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Chennai, Tamil Nadu, India.</p>

          <h3>8. Dispute Resolution</h3>
          <p>In the event of a dispute, both parties agree to first attempt an amicable settlement through Mediation. If unresolved within 30 days, the dispute shall be referred to Arbitration in accordance with the Arbitration and Conciliation Act, 1996. The venue of arbitration shall be Chennai, Tamil Nadu, India.</p>

          <h3>9. Data Retention</h3>
          <p>We keep personal information only as long as necessary for the purposes stated, or to comply with legal/contractual obligations. Standard retention periods:</p>
          <ul>
            <li><strong>Operational Enquiries</strong> – 18 months of inactivity</li>
            <li><strong>Enterprise Project Assets</strong> – 7 years after project end</li>
            <li><strong>Financial &amp; Billing Records</strong> – 7 years (tax law)</li>
            <li><strong>Engagement Preferences</strong> – Immediate once unsubscribe</li>
          </ul>

          <h3>10. Contact Us</h3>
          <p>If you have any questions about this Policy or our privacy practices, contact us:</p>
          <p>
            Email: <a href="mailto:ramesh@risingsunglobal.tech">ramesh@risingsunglobal.tech</a><br />
            Rising Sun Globalized Firm, No. 92, Opp. Sameera New Vision Township, Chennai, Tamil Nadu, India - 600048.
          </p>
        </div>
      </div>
    </div>
  );
}
